import { NuxtCookies } from 'cookie-universal-nuxt'
import { Store } from 'vuex'
import { RootState } from '@/store'
import * as types from '@/store/app/types'
import { IMenuProps } from '@/entities/Menu'
import { IAccountProps } from '@/entities/Account'
export default class AppRepository {
  private cookies: NuxtCookies
  private store: Store<RootState>

  constructor(cookies: NuxtCookies, store: Store<RootState>) {
    this.cookies = cookies
    this.store = store
  }

  get title(): string {
    return process.env.APPLICATION_NAME || 'アプリケーション'
  }

  set mobile(value: boolean) {
    const mobile = value ? 'mobile' : 'web'
    this.cookies.set('is_web_view', mobile, { path: '/', maxAge: 60 * 60 * 24 * 14 }) // 2週間
  }

  get mobile(): boolean {
    const flag = this.cookies.get('is_web_view') || 'web'
    return flag === 'mobile'
  }

  set layout(value: string) {
    this.store.commit(new types.Layout(value))
  }

  get layout(): string {
    return this.store.state.app.layout
  }

  set signup(value: IAccountProps) {
    this.store.commit(new types.Signup(value))
  }

  get signup(): IAccountProps {
    return this.store.state.app.signup
  }

  set errors(value: any) {
    this.store.commit(new types.Errors(value))
  }

  get errors(): any {
    return this.store.state.app.errors
  }

  set drawer(value: boolean | null) {
    this.store.commit(new types.Drawer(value))
  }

  get drawer(): boolean | null {
    return this.store.state.app.drawer
  }

  set alert(value: boolean | null) {
    this.store.commit(new types.Alert(value))
  }

  get alert(): boolean | null {
    return this.store.state.app.alert
  }

  set current(value: IMenuProps | undefined) {
    this.store.commit(new types.Current(value))
  }

  get current(): IMenuProps | undefined {
    return this.store.state.app.current
  }

  set redirect(value: string | null) {
    this.store.commit(new types.Redirect(value))
  }

  get redirect(): string | null {
    return this.store.state.app.redirect
  }

  set from(value: string | null | undefined) {
    this.store.commit(new types.From(value))
  }

  get from(): string | null | undefined {
    return this.store.state.app.from
  }

  set back(value: string | null | undefined) {
    this.store.commit(new types.Back(value))
  }

  get back(): string | null | undefined {
    return this.store.state.app.back
  }

  set toolbar(value: boolean) {
    this.store.commit(new types.Toolbar(value))
  }

  get toolbar(): boolean {
    return this.store.state.app.toolbar
  }

  set extension(value: boolean) {
    this.store.commit(new types.Extension(value))
  }

  get extension(): boolean {
    return this.store.state.app.extension
  }

  set initialize(value: string | null) {
    this.store.commit(new types.Initialize(value))
  }

  get initialize(): string | null {
    return this.store.state.app.initialize
  }

  set bottom(value: boolean) {
    this.store.commit(new types.Bottom(value))
  }

  get bottom(): boolean {
    return this.store.state.app.bottom
  }

  set bottomHeight(value: string) {
    this.store.commit(new types.BottomHeight(value))
  }

  get bottomHeight(): string {
    return this.store.state.app.bottomHeight
  }

  set headerHeight(value: string) {
    this.store.commit(new types.HeaderHeight(value))
  }

  get headerHeight(): string {
    return this.store.state.app.headerHeight
  }

  set observer(value: any) {
    this.store.commit(new types.Observer(value))
  }

  get observer(): any {
    return this.store.state.app.observer
  }
}
